import { createRequest } from "helpers/tools";

export const withHttpsScheme = (url) => {
    const trimmed = (url ?? "").trim();
    if (!trimmed || /^https?:\/\//i.test(trimmed)) return trimmed;
    return `https://${trimmed}`;
};

export const sendOdooData = async (data) => {
    return await createRequest({
        suffix: "odoo",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const odooMapping = async (data, id) => {
    return await createRequest({
        suffix: `odoo/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const getOdooMapping = async (id) => {
    return await createRequest({
        suffix: `odoo/${id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const getOdooTest = async (id) => {
    return await createRequest({
        suffix: `odoo/${id}/preview`,
        method: "get",
        handleError: false,
    });
};
